import React from "react";
import Row from "./Row";
import Cell from "./Cell";
import PropTypes from "prop-types";
import { bem, canRender } from "../../helpers";

const TBody = (props) => {
  const { headers, body } = props;
  const { className, data } = body;

  const bodyElement = canRender(body.data, { ...props });
  if (bodyElement.isRenderable) {
    const RenderElement = () => bodyElement.element;
    return <RenderElement />;
  } else {
    return (
      <tbody className={bem("table", "body", [], className)}>
        {data.map((row, i) => {
          return (
            <Row key={`row-${i}`} className={row.className}>
              {headers.data.map((header, i) => {
                const cell = row[header.key];
                if (cell) {
                  const cellElement = canRender(cell.data, {
                    ...props,
                    row,
                    cell,
                  });
                  if (cellElement.isRenderable) {
                    const RenderElement = () => cellElement.element;
                    return (
                      <Cell
                        key={`cell-${i}`}
                        cellType="body"
                        className={cell.className}
                      >
                        <RenderElement />
                      </Cell>
                    );
                  } else {
                    return (
                      <Cell
                        key={`${JSON.stringify(cell.data)}-${i}`}
                        cellType="body"
                        className={cell.className}
                      >
                        {cell.data}
                      </Cell>
                    );
                  }
                } else {
                  return null;
                }
              })}
            </Row>
          );
        })}
      </tbody>
    );
  }
};

TBody.propTypes = {
  headers: PropTypes.shape({
    className: PropTypes.string,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        data: PropTypes.oneOfType([
          PropTypes.element,
          PropTypes.string,
          PropTypes.number,
        ]).isRequired,
        className: PropTypes.string,
      })
    ).isRequired,
  }),
  body: PropTypes.shape({
    className: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
};

export default TBody;
